import React from 'react';
import PropTypes from 'prop-types';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button";
import Icon from "components/Selfcare/Common/Icon";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';

import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';

class OverviewSubscription extends React.Component {
    render() {
        const { parent, isAdministrating, show, subscription, t } = this.props;
        return (
            <div>
                {/*<Slide direction="down" in={show} mountOnEnter unmountOnExit>*/}
                <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={10} md={8} lg={6}>
                            <GridContainer direction="column" alignItems="flex-start">
                                <GridItem style={{ fontSize: '20px' }}>{subscription.User.Fullname}</GridItem>
                                <GridItem>{subscription.User.Email}</GridItem>
                                <GridItem>{subscription.User.AddressLine}</GridItem>
                                <GridItem>{subscription.User.PostalCode}&nbsp;&nbsp;{subscription.User.City}</GridItem>
                                {!subscription.IsPrepaid && <GridItem><Button onClick={() => { parent.navigateTo('/change-user-address'); }} color="white" size="sm" variant="text" style={{ borderRadius: "19px" }}>{t('selfcare:button.changeuserinfo')}</Button></GridItem>}
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </div>
                {/*</Slide>
                <Slide direction="up" in={show} mountOnEnter unmountOnExit>*/}

                <div style={{ paddingTop: '5px' }}>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={10} md={8} lg={6}>
                            <GridContainer justify="space-between" spacing={0}>
                                <GridItem xs={12} md={6}>
                                    <div>
                                        <List>
                                            <ListSubheader style={{ color: '#e91e60', position: 'static' }}>{t('selfcare:title.actions')}</ListSubheader>
                                            <Divider variant="inset" component="li" />
                                            {subscription && subscription.CanActivateSimCard &&
                                                <ListItem button onClick={() => { parent.navigateTo('/activate-simcard'); }}>
                                                    <ListItemAvatar>
                                                        <Icon name="simcard" size={36} color="#e91e60" />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={t('selfcare:item.activatesim')}
                                                        secondary={t('selfcare:item.receivedsimcard')}
                                                    />
                                                    <ListItemSecondaryAction>
                                                        <IconButton onClick={() => { parent.navigateTo('/Activate-simcard'); }}>
                                                            <Icon name="right-arrow" size={24} color="#e91e60" />
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>}
                                            {subscription && subscription.CanActivateSimCard &&
                                                <Divider variant="inset" component="li" />}
                                            {subscription && subscription.CanChangePriceplan &&
                                                <ListItem button onClick={() => { parent.navigateTo('/change-subscription') }}>
                                                    <ListItemAvatar>
                                                        <Icon name="money" size={36} color="#e91e60" />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                    primary={this.props.IsSweden ? t('selfcare:item.change-subscription-type-swe') : t('selfcare:item.changesubscription', { 0: `${subscription.Type}` })}
                                                        secondary={subscription.Priceplan.OpenOrder ? t('selfcare:item.orderbeingprocessed', { 0: subscription.Priceplan.Name }) : subscription.Priceplan.Name}
                                                    />
                                                    <ListItemSecondaryAction>
                                                        <IconButton onClick={() => { parent.navigateTo('/change-subscription') }}>
                                                            <Icon name="right-arrow" size={24} color="#e91e60" />
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>}
                                            {subscription && subscription.CanChangePriceplan &&
                                                <Divider variant="inset" component="li" />}
                                            <ListItem button onClick={() => parent.showPinPuk()}>
                                                <ListItemAvatar>
                                                    <Icon name="pin" size={36} color="#e91e60" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={t('selfcare:item.pinslashpuk')}
                                                    secondary={t('selfcare:item.showpinandpuk')}
                                                />
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => parent.showPinPuk()}>
                                                        <Icon name="right-arrow" size={24} color="#e91e60" />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <Divider variant="inset" component="li" />
                                            <ListItem button onClick={() => { parent.navigateTo('/blocking'); }}>
                                                <ListItemAvatar>
                                                    <Icon name="block-sim" size={36} color="#e91e60" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={t('selfcare:item.blockunlocksim')}
                                                    secondary={t('selfcare:item.lostphone')}
                                                />
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => { parent.navigateTo('/blocking'); }}>
                                                        <Icon name="right-arrow" size={24} color="#e91e60" />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <Divider variant="inset" component="li" />
                                            <ListItem button onClick={() => { parent.navigateTo('/order-simcard'); }}>
                                                <ListItemAvatar>
                                                    <Icon name="simcard" size={36} color="#e91e60" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={subscription && subscription.SimCardOrderOpen ? t('selfcare:item.ordernewsimprocessed') : t('selfcare:item.ordernewsim')}
                                                    secondary={t('selfcare:item.neednewsim')}
                                                />
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => { parent.navigateTo('/order-simcard'); }}>
                                                        <Icon name="right-arrow" size={24} color="#e91e60" />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <Divider variant="inset" component="li" />
                                            {!isAdministrating && <ListItem button onClick={() => { parent.changeAddress(); }}>
                                                <ListItemAvatar>
                                                    <Icon name="profile" size={36} color="#e91e60" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={subscription && subscription.IsPostpaid ? t('selfcare:item.invoicerecipient') : t('selfcare:item.owner')}
                                                    secondary={t('selfcare:item.newadress')}
                                                />
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => { parent.changeAddress(); }}>
                                                        <Icon name="right-arrow" size={24} color="#e91e60" />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>}
                                            {!isAdministrating && this.props.IsSweden && <React.Fragment>
                                                <Divider variant="inset" component="li" />
                                                <ListItem button onClick={() => parent.showPaymentDetails()}>
                                                    <ListItemAvatar>
                                                        <Icon name="credit-card" size={36} color="#e91e60" />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={t('selfcare:item.payment-method')}
                                                        secondary={t('selfcare:item.change-payment-method')}
                                                    />
                                                    <ListItemSecondaryAction>
                                                        <IconButton onClick={() => parent.navigateTo('/change-password')}>
                                                            <Icon name="right-arrow" size={24} color="#e91e60" />
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            </React.Fragment>}
                                            {!isAdministrating && <Divider variant="inset" component="li" />}
                                            {!isAdministrating && <ListItem button onClick={() => parent.navigateTo('/change-password')}>
                                                <ListItemAvatar>
                                                    <Icon name="lock" size={36} color="#e91e60" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={t('selfcare:item.changepassword')}
                                                    secondary={t('selfcare:item.changeyourpassword')}
                                                />
                                                <ListItemSecondaryAction>
                                                    <IconButton onClick={() => parent.navigateTo('/change-password')}>
                                                        <Icon name="right-arrow" size={24} color="#e91e60" />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>}
                                            {!isAdministrating && <Divider variant="inset" component="li" />}
                                            {subscription && subscription.ActiveServices && subscription.ActiveServices.length > 0 &&
                                                <ListSubheader style={{ color: '#e91e60', position: 'static' }}>{t('selfcare:title.activeservices')}</ListSubheader>}
                                            {subscription && subscription.ActiveServices && subscription.ActiveServices.length > 0 &&
                                                <Divider variant="inset" component="li" />}
                                            {subscription && subscription.ActiveServices && subscription.ActiveServices.length > 0 ? subscription.ActiveServices.map((service) => {
                                                return (
                                                    <div key={service.ServiceNo}>
                                                        <ListItem button onClick={() => { parent.changeService(service.ServiceNo, service.GroupId); }}>
                                                            <ListItemAvatar>
                                                                <Icon name={service.Image} size={36} color="#e91e60" />
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={service.Name}
                                                                secondary={service.Status}
                                                            />
                                                            <ListItemSecondaryAction>
                                                                <IconButton onClick={() => { parent.changeService(service.ServiceNo, service.GroupId); }}>
                                                                    <Icon name="right-arrow" size={24} color="#e91e60" />
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                        <Divider variant="inset" component="li" />
                                                    </div>
                                                );
                                            }) : null}

                                            {subscription && subscription.OtherServices && subscription.OtherServices.length > 0 &&
                                                <ListSubheader style={{ color: '#e91e60', position: 'static' }}>{t('selfcare:title.otherservices')}</ListSubheader>}
                                            {subscription && subscription.OtherServices && subscription.OtherServices.length > 0 &&
                                                <Divider variant="inset" component="li" />}
                                            {subscription && subscription.OtherServices && subscription.OtherServices.length > 0 ? subscription.OtherServices.map((service) => {
                                                return (
                                                    <div key={service.ServiceNo}>
                                                        <ListItem button onClick={() => { parent.changeService(service.ServiceNo, service.GroupId); }}>
                                                            <ListItemAvatar>
                                                                <Icon name={service.Image} size={36} color="#e91e60" />
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={service.Name}
                                                                secondary={service.Status}
                                                            />
                                                            <ListItemSecondaryAction>
                                                                <IconButton onClick={() => { parent.changeService(service.ServiceNo, service.GroupId); }}>
                                                                    <Icon name="right-arrow" size={24} color="#e91e60" />
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                        <Divider variant="inset" component="li" />
                                                    </div>
                                                );
                                            }) : null}
                                        </List>
                                    </div>
                                </GridItem>
                                <GridItem xs={12} md={6}>
                                    <table style={{ padding: '10px' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div style={{ fontSize: '1.3125rem', paddingBottom: '5px' }}>
                                                        {t('selfcare:info.needhelp')}
                                                </div>
                                                    <div>
                                                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.contact') }} />
                                                </div>
                                                </td>
                                                <td>
                                                    <Icon name="help" size={64} color="#e91e60" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </div>
                {/*</Slide>*/}
            </div>
        );
    }
}

OverviewSubscription.propTypes = {
    subscription: PropTypes.object.isRequired,
};

export default compose(
    withTranslation(),
)(OverviewSubscription);